var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcast04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3073_84055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8198 24.7537L45.3262 20.6732",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6259 35.2066L40.8584 41.9607",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7228 29.9804L43.0923 31.3171",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.09 20.6448L18.3121 19.6565",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5203 23.1792L17.7423 22.1909",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.926 36.543L26.5778 18.8873",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6465 24.6112C14.6465 26.8327 12.8457 28.6335 10.6242 28.6335C8.40279 28.6335 6.60196 26.8327 6.60196 24.6112C6.60196 22.3898 8.40279 20.5889 10.6242 20.5889C12.8457 20.5889 14.6465 22.3898 14.6465 24.6112Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2106 21.5317V3.64753C13.2106 2.88269 12.5905 2.2625 11.8256 2.2625H9.42281C8.65779 2.2625 8.03778 2.88269 8.03778 3.64753V21.5317",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1523 24.6113C12.1523 25.4553 11.4682 26.1394 10.6242 26.1394C9.78029 26.1394 9.09604 25.4553 9.09604 24.6113C9.09604 23.7673 9.78029 23.0832 10.6242 23.0832C11.4682 23.0832 12.1523 23.7673 12.1523 24.6113Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32614 15.3665C3.90706 15.967 2.79695 17.2318 2.4612 18.8549L0.775467 27.0056C0.232541 29.6304 1.92017 32.1982 4.54486 32.741L22.9261 36.5429L28.6287 43.1506C29.5437 44.2108 31.2772 43.7607 31.5609 42.3893L36.8234 16.9459C37.107 15.5745 35.6943 14.4736 34.4338 15.0839L26.5778 18.8873L15.8431 16.667",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3073_84055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast04);
export default __webpack_public_path__ + "static/media/Broadcast04.a1484e2db114e0ae65f87f0c3dff95b2.svg";
export { ForwardRef as ReactComponent };